/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthSubmissionLeadFacility } from './PalAuthSubmissionLeadFacility';
import {
    PalAuthSubmissionLeadFacilityFromJSON,
    PalAuthSubmissionLeadFacilityFromJSONTyped,
    PalAuthSubmissionLeadFacilityToJSON,
    PalAuthSubmissionLeadFacilityToJSONTyped,
} from './PalAuthSubmissionLeadFacility';
import type { ReimbursementType } from './ReimbursementType';
import {
    ReimbursementTypeFromJSON,
    ReimbursementTypeFromJSONTyped,
    ReimbursementTypeToJSON,
    ReimbursementTypeToJSONTyped,
} from './ReimbursementType';
import type { ContractSummary } from './ContractSummary';
import {
    ContractSummaryFromJSON,
    ContractSummaryFromJSONTyped,
    ContractSummaryToJSON,
    ContractSummaryToJSONTyped,
} from './ContractSummary';
import type { InsuranceType } from './InsuranceType';
import {
    InsuranceTypeFromJSON,
    InsuranceTypeFromJSONTyped,
    InsuranceTypeToJSON,
    InsuranceTypeToJSONTyped,
} from './InsuranceType';

/**
 * 
 * @export
 * @interface PalReauthCreationInsurance
 */
export interface PalReauthCreationInsurance {
    /**
     * 
     */
    payor: PalAuthSubmissionLeadFacility;
    /**
     * 
     */
    insurance_type: InsuranceType;
    /**
     * 
     */
    coverage_priority: PalReauthCreationInsuranceCoveragePriorityEnum;
    /**
     * False for Medicare and Medicaid. Only managed care, Commercial, Other and Private Pay insurances can be used for a manual re-auth.
     */
    is_allowed_type: boolean;
    /**
     * 
     */
    reimbursement_type: ReimbursementType;
    /**
     * True when the facility has no completed contract for this payer and type. The re-auth is then tracked as out of network on PDPM.
     */
    is_oon: boolean;
    /**
     * 
     */
    contract: ContractSummary | null;
}


/**
 * @export
 */
export const PalReauthCreationInsuranceCoveragePriorityEnum = {
    Primary: 'Primary',
    Secondary: 'Secondary',
    Tertiary: 'Tertiary',
} as const;
export type PalReauthCreationInsuranceCoveragePriorityEnum = typeof PalReauthCreationInsuranceCoveragePriorityEnum[keyof typeof PalReauthCreationInsuranceCoveragePriorityEnum];


/**
 * Check if a given object implements the PalReauthCreationInsurance interface.
 */
export function instanceOfPalReauthCreationInsurance(value: object): value is PalReauthCreationInsurance {
    if (!('payor' in value) || value['payor'] === undefined) return false;
    if (!('insurance_type' in value) || value['insurance_type'] === undefined) return false;
    if (!('coverage_priority' in value) || value['coverage_priority'] === undefined) return false;
    if (!('is_allowed_type' in value) || value['is_allowed_type'] === undefined) return false;
    if (!('reimbursement_type' in value) || value['reimbursement_type'] === undefined) return false;
    if (!('is_oon' in value) || value['is_oon'] === undefined) return false;
    if (!('contract' in value) || value['contract'] === undefined) return false;
    return true;
}

export function PalReauthCreationInsuranceFromJSON(json: any): PalReauthCreationInsurance {
    return PalReauthCreationInsuranceFromJSONTyped(json, false);
}

export function PalReauthCreationInsuranceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthCreationInsurance {
    if (json == null) {
        return json;
    }
    return {
        
        'payor': PalAuthSubmissionLeadFacilityFromJSON(json['payor']),
        'insurance_type': InsuranceTypeFromJSON(json['insurance_type']),
        'coverage_priority': json['coverage_priority'],
        'is_allowed_type': json['is_allowed_type'],
        'reimbursement_type': ReimbursementTypeFromJSON(json['reimbursement_type']),
        'is_oon': json['is_oon'],
        'contract': ContractSummaryFromJSON(json['contract']),
    };
}

export function PalReauthCreationInsuranceToJSON(json: any): PalReauthCreationInsurance {
    return PalReauthCreationInsuranceToJSONTyped(json, false);
}

export function PalReauthCreationInsuranceToJSONTyped(value?: PalReauthCreationInsurance | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payor': PalAuthSubmissionLeadFacilityToJSON(value['payor']),
        'insurance_type': InsuranceTypeToJSON(value['insurance_type']),
        'coverage_priority': value['coverage_priority'],
        'is_allowed_type': value['is_allowed_type'],
        'reimbursement_type': ReimbursementTypeToJSON(value['reimbursement_type']),
        'is_oon': value['is_oon'],
        'contract': ContractSummaryToJSON(value['contract']),
    };
}

